import React from "react";
import { ArrowRight } from "lucide-react";
import { specialtyHref } from "../../lib/specialties";

const symptoms = [
  // Espasticidade
  {
    title: "Rigidez muscular pós-AVC",
    desc: "Aumento do tônus após lesão neurológica, dificultando movimentos, higiene e reabilitação.",
    slug: "espasticidade",
  },
  {
    title: "Dor e espasmos musculares",
    desc: "Contrações dolorosas e persistentes que atrapalham cuidados diários e a qualidade de vida.",
    slug: "espasticidade",
  },
  // Distonia
  {
    title: "Contrações musculares involuntárias",
    desc: "Movimentos que aparecem sem controle voluntário, gerando desconforto e limitação.",
    slug: "distonia",
  },
  {
    title: "Movimentos repetitivos e posturas anormais",
    desc: "Torções, inclinações mantidas ou movimentos que se repetem — sinais clássicos de distonia.",
    slug: "distonia",
  },
  // Enxaqueca
  {
    title: "Dor de cabeça intensa e pulsátil",
    desc: "Crises latejantes, muitas vezes de um lado da cabeça, que interrompem o dia.",
    slug: "enxaqueca",
  },
  {
    title: "Náuseas e sensibilidade à luz e ao som",
    desc: "Sintomas típicos da enxaqueca que exigem escuridão, silêncio e afastamento das atividades.",
    slug: "enxaqueca",
  },
];

export const Symptoms = () => {
  return (
    <section id="sintomas" data-testid="symptoms-section" className="py-20 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl">
          <p className="overline text-[#D4AF37] mb-5">Reconheça os sinais</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0A2540] leading-tight tracking-tight">
            Você sofre com algum destes sintomas?
          </h2>
          <p className="mt-6 text-[#1A1A1A]/70 text-lg leading-relaxed">
            Conviver diariamente com a dor ou com movimentos fora do seu controle
            não deve ser considerado normal. Identificar o sintoma é o primeiro
            passo para um tratamento adequado.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {symptoms.map((s, i) => (
            <div
              key={s.title}
              data-testid={`symptom-card-${i}`}
              className="card-lift bg-[#F8F9FA] border-l-4 border-[#D4AF37] rounded-r-lg p-7 flex flex-col"
            >
              <h3 className="font-serif-display text-xl sm:text-2xl text-[#0A2540] mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-[#1A1A1A]/70 leading-relaxed flex-1">{s.desc}</p>
              <a
                href={specialtyHref(s.slug)}
                data-testid={`symptom-saiba-mais-${i}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0D3B66] hover:text-[#D4AF37] transition-colors group"
              >
                Saiba mais
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
